
// ComplementoField.js

import React from 'react';

function ComplementoField({ value, onChange }) {
  return (
    <div style={{ marginBottom: '0px' }}>
      <input 
        type="text"
        placeholder="Digite o Complemento do Endereço"
        style={{ width: '160px', height: '30px' }}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

export default ComplementoField;